import { loadable } from 'utils';

export const Basic = loadable(() => import('./Basic'), {});
export const Create = loadable(() => import('./Create'), {});
